module.exports = __webpack_public_path__ + "static/media/sectionFourPhotoThree.ffc08734.jpg";